export const BuildStateValues = ['WAITING', 'IN_PROGRESS', 'SUCCESS', 'FAILED'] as const;
export type BuildState = (typeof BuildStateValues)[number];
export const BuildTypeValues = ['ROVO_AGENT', 'AUTOMATION_RULE', 'ECOSYSTEM_APP'] as const;
export type BuildType = (typeof BuildTypeValues)[number];

export const PlanStateValues = ['DRAFT', 'DISABLED', 'IN_PROGRESS', 'COMPLETED'] as const;
export type PlanState = (typeof PlanStateValues)[number];

export type BuildResponse = {
	id: string;
	dependencies: number[];
	name: string;
	number: number;
	overview: string;
	state: BuildState;
	type: BuildType;
	ari?: string | null | undefined;
};

export type Build = BuildResponse & {
	conversationId: string;
	solutionId: string;
	solutionVersion: string;
};

export type SolutionPlanResponse = {
	builds: {
		sequence: BuildResponse[];
	};
	conversationId: string;
	spaceId: string;
	id: string;
	name: string;
	solutionVersion: string;
	currentBuildNumber: number;
	state: PlanState;
};

export type SolutionPlan = Omit<SolutionPlanResponse, 'builds'> & {
	builds: Build[];
};

export type SolutionBuildResponse = {
	ari: string | null | undefined;
	buildId: string | null | undefined;
	state: BuildState;
	type: BuildType;
};
